<template>
  <div class="login-credentials" :class="{ mobile: isMobile }">
    <!-- LOGIN -->
    <div v-if="tab === 'login'">
      <!-- Kullanıcı Adı -->
      <div class="credentials-element">
        <label class="element-title">{{ $t('login.username') }}</label>
        <div class="input-container">
          <i class="icon fas fa-user"></i>
          <input
            v-model="loginUsername"
            type="text"
            :placeholder="$t('register.usernamePlaceholder')"
            class="input-field"
          />
        </div>
      </div>

      <!-- Şifre -->
      <div class="credentials-element">
        <label class="element-title">{{ $t('login.password') }}</label>
        <div class="input-container">
          <i class="icon fas fa-lock"></i>
          <input
            v-model="loginPassword"
            type="password"
            :placeholder="$t('register.passwordPlaceholder')"
            class="input-field"
          />
          <button @click="$parent.modalSetTab('forgot')" class="forgot-link">
            {{ $t('login.forgot') }}
          </button>
        </div>
      </div>
    </div>

    <!-- REGISTER -->
    <div v-if="tab === 'register'">
      <!-- Name + Username -->
      <div class="credentials-row">
        <div class="credentials-element">
          <label class="element-title">{{ $t('register.name') }}</label>
          <div class="input-container">
            <i class="icon fas fa-user"></i>
            <input
              v-model="loginNameSurname"
              type="text"
              :placeholder="$t('register.namePlaceholder')"
              class="input-field"
            />
          </div>
        </div>
        <div class="credentials-element">
          <label class="element-title">{{ $t('register.username') }}</label>
          <div class="input-container">
            <i class="icon fas fa-at"></i>
            <input
              v-model="loginUsername"
              type="text"
              :placeholder="$t('register.usernamePlaceholder')"
              class="input-field"
            />
          </div>
        </div>
      </div>

      <!-- Phone + Email -->
      <div class="credentials-row">
        <div class="credentials-element">
          <label class="element-title">{{ $t('register.phone') }}</label>
          <div class="phone-input">
            <!-- Country Code -->
          <CustomDropdown
  v-model="selectedCountryCode"
  :options="countryCodes.map(c => ({
    value: c.dial_code,
    label: `${c.dial_code} `
  }))"
/>


            <!-- Phone Number -->
            <input
              v-model="loginPhone"
              type="tel"
              inputmode="numeric"
              pattern="[0-9]*"
              :placeholder="$t('register.phonePlaceholder')"
              class="phone-number"
            />
          </div>
        </div>

        <div class="credentials-element">
          <label class="element-title">{{ $t('register.mail') }}</label>
          <div class="input-container">
            <i class="icon fas fa-envelope"></i>
            <input
              v-model="loginEmail"
              type="text"
              :placeholder="$t('register.mailPlaceholder')"
              class="input-field"
            />
          </div>
        </div>
      </div>

      <!-- CPF (sadece Brezilya IP'lerinde görünür) -->
<div v-if="showCPFField" class="credentials-element">
  <label class="element-title">CPF</label>
  <div class="input-container">
    <i class="icon fas fa-id-card"></i>
    <input
      v-model="loginIdNumber"
      type="text"
      inputmode="numeric"
      maxlength="11"
      minlength="11"
      pattern="[0-9]*"
      placeholder="00000000000"
      class="input-field"
      @input="onCPFInput"
    />
  </div>
  <small v-if="cpfError" class="error-text">{{ cpfError }}</small>
</div>

      <!-- Birthday -->
      <div class="credentials-row">
        <div class="credentials-element">
          <label class="element-title">{{ $t('register.birthday') }}</label>
          <div class="input-container">
            <i class="icon fas fa-calendar"></i>
            <input v-model="loginBirthday" type="date" class="input-field" />
          </div>
        </div>
      </div>

      <!-- Passwords -->
      <div class="credentials-row">
        <div class="credentials-element">
          <label class="element-title">{{ $t('register.password') }}</label>
          <div class="input-container">
            <i class="icon fas fa-lock"></i>
            <input
              v-model="loginPassword"
              type="password"
              :placeholder="$t('register.passwordPlaceholder')"
              class="input-field"
              @focus="showPasswordRules = true"
              @blur="hidePasswordRules"
            />
          </div>
          <ul v-if="showPasswordRules" class="password-rules">
            <li :class="{ valid: passwordRules.minLength }">{{ $t('passwordRules.minLength') }}</li>
            <li :class="{ valid: passwordRules.uppercase }">{{ $t('passwordRules.uppercase') }}</li>
            <li :class="{ valid: passwordRules.lowercase }">{{ $t('passwordRules.lowercase') }}</li>
            <li :class="{ valid: passwordRules.number }">{{ $t('passwordRules.number') }}</li>
            <li :class="{ valid: passwordRules.special }">{{ $t('passwordRules.special') }}</li>
          </ul>
        </div>

        <div class="credentials-element">
          <label class="element-title">{{ $t('register.passwordag') }}</label>
          <div class="input-container">
            <i class="icon fas fa-lock"></i>
            <input
              v-model="loginPasswordConfirm"
              type="password"
              :placeholder="$t('register.passwordagPlaceholder')"
              class="input-field"
            />
          </div>
        </div>
      </div>

      <!-- Currency -->
      <div class="credentials-element">
        <label class="element-title"> {{ $t('register.Currency') }}</label>
        <div class="input-container">
          
          <CustomDropdown
  v-model="selectedCurrency"
  :options="fiatCurrencies.map(c => ({
    value: c.code,  // 🔑 sadece code seçiliyor
    label: c.label
  }))"
/>
        </div>
      </div>
      <!-- Affiliate Code -->
<div class="credentials-element">
  <label class="element-title">{{ $t('register.affiliate') }}</label>
  <div class="input-container">
    <i class="icon fas fa-gift"></i>
    <input
      v-model="loginAffiliateCode"
      type="text"
      :placeholder="$t('register.affiliatePlaceholder')"
      class="input-field"
    />
  </div>
</div>
    </div>

    

    <!-- Buttons -->
    <div class="credentials-buttons">
      <button
        @click="$parent.modalSetTab(tab === 'login' ? 'register' : 'login')"
        class="toggle-btn"
        :class="{ active: tab === 'register' }"
      >
        {{ tab === 'login' ? $t('buttons.register') : $t('buttons.login') }}
      </button>
      <button
        @click="loginActionButton"
        class="action-btn"
        :disabled="authSendLoginLoading === true"
      >
        <span v-if="authSendLoginLoading" class="btn-loading">
          <i class="fas fa-spinner fa-spin"></i>
        </span>
        <span v-else>{{ $t(`buttons.${tab}`) }}</span>
      </button>
    </div>

<!-- Google ile giriş -->
<div id="googleBtn" style="margin-top: 10px; display: none;"></div>



    <!-- Terms -->
    <div v-if="tab === 'register'" class="terms">
      {{ $t('register.credent') }}
      <button @click="loginTermsButton()" class="terms-link">
        {{ $t('register.terms') }}
      </button>.
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import countryCodes from "@/assets/data/countryCodes.json";
import CustomDropdown from "@/components/CustomDropdown.vue";
import axios from "axios";

export default {
  name: "LoginCredentials",
  components: { CustomDropdown },
  props: ["tab"],
  data() {
    return {
      isMobile: window.innerWidth <= 768,
      loginMethod: "username",
      loginUsername: null,
      loginEmail: null,
      loginPhone: null,
      loginNameSurname: null,
      loginBirthday: null,
      loginIdNumber: null,
      showCPFField: false,
      cpfError: null,
      loginPassword: null,
      loginPasswordConfirm: null,
      selectedCountryCode: "+1",
      selectedCurrency: "USD",
      showPasswordRules: false,
      loginAffiliateCode: null,
      countryCodes,
      fiatCurrencies: [
        { code: "USD", label: "USD - US Dollar" },
        { code: "GBP", label: "GBP - British Pound" },
        { code: "CAD", label: "CAD - Canadian Dollar" },
        { code: "AUD", label: "AUD - Australian Dollar" },
        { code: "EUR", label: "EUR - Euro" },
        { code: "TRY", label: "TRY - Turkish Lira" },
        { code: "BRL", label: "BRL - Brazilian Real" },
        { code: "MXN", label: "MXN - Mexican Peso" },
        { code: "INR", label: "INR - Indian Rupee" },
        { code: "JPY", label: "JPY - Japanese Yen" },
        { code: "KRW", label: "KRW - South Korean Won" },
        { code: "PHP", label: "PHP - Philippine Peso" },
        { code: "ZAR", label: "ZAR - South African Rand" },
        { code: "RUB", label: "RUB - Russian Ruble" },
        { code: "SEK", label: "SEK - Swedish Krona" },
        { code: "NOK", label: "NOK - Norwegian Krone" },
        { code: "DKK", label: "DKK - Danish Krone" },
        { code: "SGD", label: "SGD - Singapore Dollar" },
        { code: "MYR", label: "MYR - Malaysian Ringgit" },
        { code: "THB", label: "THB - Thai Baht" },
        { code: "VND", label: "VND - Vietnamese Dong" },
        { code: "ARS", label: "ARS - Argentine Peso" },
        { code: "COP", label: "COP - Colombian Peso" },
        { code: "CLP", label: "CLP - Chilean Peso" },
        { code: "CNY", label: "CNY - Chinese Yuan" },
        { code: "BDT", label: "BDT - Bangladesh Taka" }
      ]
    };
  },
  mounted() {
    this.detectCountryData();

      // ✅ URL'den affiliate code yakala
  const urlParams = new URLSearchParams(window.location.search);
  const affiliate = urlParams.get("a");
  if (affiliate) {
    this.loginAffiliateCode = affiliate;
  }

    // ✅ Backend’den clientId çek (gerekirse ayarlardan)
    fetch("/settings")
      .then(res => res.json())
      .then(data => {
        if (data.googleClientId) {
          google.accounts.id.initialize({
            client_id: data.googleClientId,
            callback: this.handleGoogleResponse
          });

          google.accounts.id.renderButton(
            document.getElementById("googleBtn"),
            { theme: "outline", size: "large" }
          );
        }
      });
  },
  methods: {
    ...mapActions([
      "modalsSetShow",
      "modalsSetData",
      "notificationShow",
      "authSendCredentialsLogin",
      "authSendCredentialsRegister"
    ]),

     onCPFInput() {
    // Yalnızca rakamları kabul et
    this.loginIdNumber = this.loginIdNumber.replace(/\D/g, "");
    if (this.loginIdNumber.length > 11) {
      this.loginIdNumber = this.loginIdNumber.slice(0, 11);
    }

    // Hata mesajı kontrolü
    if (this.loginIdNumber && this.loginIdNumber.length !== 11) {
      this.cpfError = "CPF numarası 11 haneli olmalıdır";
    } else {
      this.cpfError = null;
    }
  },

async handleGoogleResponse(response) {
  console.log("Google Response:", response);

  try {
    const idToken = response.credential;
    console.log("ID Token:", idToken);

    const res = await axios.post("/auth/social/google", {
      token: idToken
    });

    if (res.data.extraInfoRequired) {
      this.modalsSetData({
        type: "socialComplete",
        data: { userId: res.data.userId }
      });
      this.modalsSetShow("SocialComplete");
    } else {
      // ✅ store mantığıyla aynı
      localStorage.setItem("token", res.data.token);
      axios.defaults.headers.common["x-auth-token"] = res.data.token;

      this.$store.commit("auth_set_token", res.data.token);
      this.$store.commit("auth_set_user", res.data.user);

      this.$store.dispatch("socketConnectGeneral");
      this.$store.dispatch("socketConnectCashier");

      if (res.data.user.rank === "admin" || res.data.user.rank === "mod") {
        this.$store.dispatch("socketConnectAdmin");
      }

      this.notificationShow({ type: "success", message: "Giriş başarılı" });
      this.$store.dispatch("modalsSetShow", null);
    }
  } catch (err) {
    console.error("Google login error:", err);
    this.notificationShow({
      type: "error",
      message: "Google ile giriş başarısız"
    });
  }
}

,


    loginActionButton() {
      let loginData = {};

      if (this.tab === "login") {
        loginData = { username: this.loginUsername, password: this.loginPassword };
        this.modalsSetData({ typeCaptcha: "credentialsLogin", data: loginData });
      } else {
        if (this.loginPassword !== this.loginPasswordConfirm) {
          this.notificationShow({ type: "error", message: this.$t("errors.passwordMismatch") });
          return;
        }

        // Telefon numarasını +90 yerine 90 şeklinde gönder
const fullPhoneNumber = `${this.selectedCountryCode.replace("+", "")}${this.loginPhone}`;


        this.modalsSetData({
          typeCaptcha: "credentialsRegister",
          data: {
            name: this.loginNameSurname,
            username: this.loginUsername,
            email: this.loginEmail,
            phone: fullPhoneNumber,
            birthday: this.loginBirthday,
            idNumber: this.loginIdNumber,
            password: this.loginPassword,
            fiatCurrency: this.selectedCurrency,
             affiliate: this.loginAffiliateCode
          }
        });
      }

      setTimeout(() => {
        this.modalsSetShow("Captcha");
      }, 200);
    },

    loginTermsButton() {
      this.modalsSetShow(null);
      setTimeout(() => {
        this.modalsSetShow("Terms");
      }, 300);
    },

    hidePasswordRules() {
      setTimeout(() => (this.showPasswordRules = false), 200);
    },

async detectCountryData() {
  try {
    const res = await fetch("https://ipapi.co/json/");
    if (res.ok) {
      const data = await res.json();

      // 🌍 Brezilya kontrolü
      if (data.country_code === "BR") {
        this.showCPFField = true;
      } else {
        this.showCPFField = false;
      }

     if (data.country_calling_code) {
        this.selectedCountryCode = data.country_calling_code; // UI'da +90 olarak görünecek
      }
      
      // 🌍 Para birimi
      const countryToCurrency = {
        US: "USD",
        GB: "GBP",
        CA: "CAD",
        AU: "AUD",
        EU: "EUR",
        TR: "TRY",
        BR: "BRL",
        MX: "MXN",
        IN: "INR",
        JP: "JPY",
        KR: "KRW",
        PH: "PHP",
        ZA: "ZAR",
        RU: "RUB",
        SE: "SEK",
        NO: "NOK",
        DK: "DKK",
        SG: "SGD",
        MY: "MYR",
        TH: "THB",
        VN: "VND",
        AR: "ARS",
        CO: "COP",
        CL: "CLP",
        CN: "CNY",
        HK: "CNY",
        TW: "CNY",
        MO: "CNY",
        BDT: "BDT"
      };

      let detectedCurrency = data.currency || null;
      if (!detectedCurrency || !this.fiatCurrencies.find(c => c.code === detectedCurrency)) {
        detectedCurrency = countryToCurrency[data.country_code] || "USD";
      }

      const match = this.fiatCurrencies.find(c => c.code === detectedCurrency);
      this.selectedCurrency = match ? match.code : "USD";
    }
  } catch (e) {
    this.selectedCountryCode = "1";
    this.selectedCurrency = "USD";
  }
},


  },
  computed: {
    passwordRules() {
      const pass = this.loginPassword || "";
      return {
        minLength: pass.length >= 8,
        uppercase: /[A-Z]/.test(pass),
        lowercase: /[a-z]/.test(pass),
        number: /[0-9]/.test(pass),
        special: /[!@#$%^&*(),.?":{}|<>]/.test(pass)
      };
    },
    ...mapGetters(["authSendLoginLoading"])
  }
};
</script>







<style scoped>
/* Genel */
.login-credentials {
  width: 100%;
  max-width: 520px;
  margin: 0 auto;
      font-family: "Rubik", sans-serif;
    font-size: 14px;
    font-variant-numeric: lining-nums tabular-nums;
    font-weight: 600;
  padding-bottom: 50px;
}

.login-credentials.mobile {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: var(--background);
  border-radius: 20px 20px 0 0;
  padding: 25px 20px;
  z-index: 9999;
  max-height: 90%;
  overflow-y: auto;
  animation: slideUp 0.3s ease;
  box-shadow: 0 -10px 30px rgba(0, 0, 0, 0.5);
}

@keyframes slideUp {
  from { transform: translateY(100%); }
  to { transform: translateY(0); }
}

/* Input Container */
.input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.icon {
  position: absolute;
  left: 15px;
  color: #fff;
  z-index: 2;
  font-size: 14px;
  transition: color 0.2s ease;
}

.input-container:focus-within .icon {
  color: var(--background4);
}

/* Elemanlar */
.credentials-element {
  
  width: 100%;
}

.credentials-row {
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
}

.element-title {
  font-size: 13px;
  font-weight: 600;
  color: #94a3b8;
  margin-bottom: 8px;
  display: block;
}

/* Standart input */
.input-field {
  width: 100%;
  height: 50px;
  padding: 0 14px 0 40px;
  font-size: 14px;
  color: #f1f5f9;
      background: var(--background2);
    border: 2px solid var(--bar-outer);
  border-radius: 12px;
  outline: none;
  transition: all 0.3s ease;
  font-weight: 500;
}

.input-field:focus {
  border-color: var(--background4);
  box-shadow: 0 0 0 3px rgba(142, 1, 224, 0.1);
}

.input-field::placeholder {
  color: #fff;
}

/* === PHONE INPUT === */
.phone-input {
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
  background: var(--background2);
  border: 2px solid var(--bar-outer);
  border-radius: 12px;
  overflow: hidden;
}

.phone-input:focus {

   border-color: var(--background4);
  box-shadow: 0 0 0 3px rgba(142, 1, 224, 0.1);
}

/* Country Select */
.country-select {
  flex: 0 0 50px;   /* sabit genişlik */
  min-width: 0;     /* default min-width devre dışı */
  box-sizing: border-box;
  height: 100%;
  border: none;
  outline: none;
  background: transparent;
  color: #f1f5f9;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  cursor: pointer;
  appearance: none;
  border-right: 2px solid #191939;
  
}

.country-select option {
  background: #0f172a;  /* dark background */
  color: #f1f5f9;       /* light text */
  padding: 8px 12px;
}


/* Phone Number */
.phone-number {
  flex: 1;
  height: 100%;
  border: none;
  outline: none;
  background: transparent;
  color: #f1f5f9;
  padding: 0 14px;
  font-size: 14px;
  font-weight: 500;
}

.phone-number::placeholder {
  color: #fff;
}

/* Mobil */
@media (max-width: 480px) {
  .credentials-row {
    flex-direction: column;
    gap: 15px;
  }
    
}

/* Şifre alanı */
.forgot-link {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  color: #000;
  border: none;
  background: none;
  cursor: pointer;
  font-weight: 600;
  transition: color 0.2s ease;
  z-index: 2;
}
 
/* Butonlar */
.credentials-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
  gap: 12px;
}

.toggle-btn,
.action-btn {
  flex: 1;
  height: 50px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  border: none;
  font-size: 14px;
  transition: all 0.3s ease;
}

.toggle-btn {
  background: var(--background2);
  color: #fff;
  
}

 
 

.action-btn {
      background: var(--buttonyellow);
    box-shadow: rgb(197, 106, 24) 0px -3px 0px 0px inset, rgb(255, 234, 47) 0px 2px 0px 0px inset;
    color: #fff;
    text-shadow: -1px -1px 0 var(--roo-btn-text-stroke-color, #C56A18), 1px -1px 0 var(--roo-btn-text-stroke-color, #C56A18), -1px 1px 0 var(--roo-btn-text-stroke-color, #C56A18), 1px 1px 0 var(--roo-btn-text-stroke-color, #C56A18);
    border-radius: 12px;
  font-weight: 700;
}

 
.action-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.btn-loading {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Terms */
.terms {
  margin-top: 20px;
  font-size: 12px;
  color: #fff;
  text-align: center;
  line-height: 1.5;
}

.terms-link {
  color: #01e0a3;
  background: none;
  border: none;
  font-weight: 600;
  cursor: pointer;
  transition: color 0.2s ease;
}

.terms-link:hover {
  color: #00c891;
  text-decoration: underline;
}

.password-rules {
  margin-top: 8px;
  font-size: 12px;
  list-style: none;
  padding: 0;
  color: #fff; /* default gri */
}

.password-rules li {
  margin-bottom: 4px;
  transition: color 0.3s ease;
}

.password-rules li.valid {
  color: green; /* mor */
  font-weight: 600;
}

.styled-select {
  width: 100%;
  height: 50px;
  padding: 0 14px;
  font-size: 14px;
  font-weight: 500;
  color: #f1f5f9;
  background: var(--background1);
  border: 2px solid var(--bar-outer);
  border-radius: 10px;
  outline: none;
  cursor: pointer;
  appearance: none;
}

.styled-select:focus {
  border-color: var(--background4);
  box-shadow: 0 0 0 3px rgba(142, 1, 224, 0.1);
}

.styled-select option {
  background: #0f172a;
  color: #f1f5f9;
  padding: 10px;
}

.input-container .custom-dropdown {
  flex: 1;
  
}

.google-btn {
  background: #fff;
  border: 1px solid #ddd;
  color: #444;
  padding: 10px 20px;
  border-radius: 5px;
  font-weight: 500;
  cursor: pointer;
  width: 100%;
  margin-top: 10px;
}
.google-btn i {
  margin-right: 8px;
  color: #DB4437;
}


.error-text {
  color: #e74c3c;
  font-size: 12px;
  margin-top: 4px;
}

.input-field:invalid {
  border-color: #e74c3c;
}

</style>
